import theme from '../theme';

import { pipe } from 'fp-ts/function';
import * as R from 'fp-ts/Record';
import { BreakPoints, css, DefaultTheme, ThemeProps } from 'styled-components';
import * as String from 'fp-ts/string';

export const mediaMin = pipe(
  theme.breakpoints,
  R.reduceWithIndex(String.Ord)(
    {} as Readonly<Record<Extract<keyof BreakPoints, string>, (props: ThemeProps<DefaultTheme>) => string>>,
    (key, acc) => ({
      ...acc,
      [key]: (props: ThemeProps<DefaultTheme>) => `min-width: ${props.theme.breakpoints[key] + 1}px`,
    }),
  ),
);

export const mediaMax = pipe(
  theme.breakpoints,
  R.reduceWithIndex(String.Ord)(
    {} as Readonly<Record<Extract<keyof BreakPoints, string>, (props: ThemeProps<DefaultTheme>) => string>>,
    (key, acc) => ({
      ...acc,
      [key]: (props: ThemeProps<DefaultTheme>) => `max-width: ${props.theme.breakpoints[key]}px`,
    }),
  ),
);

export const mediaHeightMax = (first: any, ...interpolation: any[]) => css`
  @media screen and (max-height: 700px) {
    ${css(first, ...interpolation)}
  }
`;
